import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectListingBundle = (state: RootState) => state.listingBundle;

const selectListingsBundle = createSelector(
  selectListingBundle,
  (state) => state.ListingBundleData
);

const selectListingBundleLoading = createSelector(
  selectListingBundle,
  (state) => state.createListingBundleLoading
);

export const selectors = {
  selectListingsBundle,
  selectListingBundleLoading
};
